import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { Data } from "../../../Pages/UserVideoLessonDetail/ILessonsList";

// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = Data;

export const ListVideoLessonsListSlice = createSlice({
  name: "ListVideoLessonsListSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    listVideoLessonsLists: (state, action) => {
      state.isLoading = true;
    },

    successListVideoLessonsLists: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureListVideoLessonsLists: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearListVideoLessonsLists: (state) => {
      state.data = {};
    },
  },
});

export const {
  listVideoLessonsLists,
  successListVideoLessonsLists,
  failureListVideoLessonsLists,
  clearListVideoLessonsLists,
} = ListVideoLessonsListSlice.actions;

export default ListVideoLessonsListSlice.reducer;
